<template>
  <div class="lawyerS">
    <div class="lawyerSS">
      <!--      <img src="../assets/img/风采.png" style="width: 13.6%;float: left;margin-left: 90px">-->
      <h2>彩虹律师高级合伙人团队</h2>
      <div class="lunbo">
        <div class="block">
          <!--<span class="demonstration">Click 指示器触发</span>-->
          <!--          <el-carousel :autoplay="false" :loop="false" trigger="click" height="380px">-->
          <el-carousel trigger="click" height="380px">
            <el-carousel-item v-for="(item,i) in ImgList" :key="i">
              <div class="card" v-for="(image,index) in item" :key="index">
                <div class="show" @mouseenter="showIs(index,i)">
                  <div class="img" :style="{'background': 'url('+image.src+')'}"></div>
                  <p>{{ image.name }}</p>
                  <p>{{ image.rainbow }}</p>
                  <p>{{ image.company }}</p>
                  <!--                  <p>{{ image.school }}</p>-->
                </div>
                <div @mouseout="noShow(index,i)" class="none">
                  <span>{{ image.txt }}</span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lawyerS",
  data() {
    return {
      ImgList: {
        one: [
          {
            id: 0,
            src: require('../assets/lbtuimaj/张慧靖1.png'),
            name: '张慧婧',
            rainbow: '合伙人律师',
            company: '擅长领域：企业法律顾问 公司法',
          },
          {
            id: 1,
            src: require('../assets/lbtuimaj/冯红1.png'),
            name: '冯红',
            rainbow: '合伙人律师',
            company: '擅长领域：婚姻纠纷 公司法',
          },
          {
            id: 2,
            src: require('../assets/lbtuimaj/陆旸1.jpg'),
            name: '陆旸',
            rainbow: '合伙人律师',
            company: '擅长领域：婚姻纠纷 公司法',

          }
        ],
        two: [
          {
            id: 3,
            src: require('../assets/lbtuimaj/冯红1.png'),
            name: '冯红',
            rainbow: '合伙人律师',
            company: '擅长领域：婚姻纠纷 公司法',
            txt: '冯红律师是资深合伙人，在公司法律事务领域，拥有专业知识和丰富的执业经验，具备高超的谈判技能和超强的专业策划能力，熟悉公司法律风险防控的预防和处理，为企业定制公司章程、各类合同文书，合同违约索赔，资信调查等各种非诉讼业务和劳动仲裁、诉讼等业务。'
          },
          {
            id: 4,
            src: require('../assets/lbtuimaj/陆旸1.jpg'),
            name: '陆旸',
            rainbow: '合伙人律师',
            company: '擅长领域：婚姻纠纷 公司法',
            school: '上海大学法学院院聘副教授',
            txt: '陆旸律师是资深合伙人，有多年的执业经验，为多家企业及个人提供法律服务，办理了大量的案件，在办案过程中积累丰富的实务经验，通过专业沟通，通过风险把控，运用法律武器，结合自身专业领域和司法实践中的经验，坚持从当事人的角度考虑，切实有效地维护了当事人的合法权益，擅长处理婚姻纠纷、建设工程类纠纷等。'
          },
          {
            id: 5,
            src: require('../assets/lbtuimaj/陈瑾.jpg'),
            name: '陈瑾',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
        ],
        three: [
          {
            id: 6,
            src: require('../assets/lbtuimaj/陆旸1.jpg'),
            name: '陆旸',
            rainbow: '合伙人律师',
            company: '擅长领域：婚姻纠纷 公司法',
            school: '上海大学法学院院聘副教授',
            txt: '陆旸律师是资深合伙人，有多年的执业经验，为多家企业及个人提供法律服务，办理了大量的案件，在办案过程中积累丰富的实务经验，通过专业沟通，通过风险把控，运用法律武器，结合自身专业领域和司法实践中的经验，坚持从当事人的角度考虑，切实有效地维护了当事人的合法权益，擅长处理婚姻纠纷、建设工程类纠纷等。'
          },
          {
            id: 7,
            src: require('../assets/lbtuimaj/陈瑾.jpg'),
            name: '陈瑾',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
          {
            id: 8,
            src: require('../assets/lbtuimaj/何慧君1.png'),
            name: '何惠君',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '张雪律师在法律领域有4年的公司法务及5年的律师事务所工作经验。精通公司法务层面的工作、员工法律培训、受托代理劳动仲裁、公证、诉讼等业务。进入律师事务所后为多家企业及个人提供法律服务；熟悉公司法律风险防控的预防和处理，为客户定制公司章程、各类合同文书，合同违约索赔，资信调查等各种非诉讼业务和劳动仲裁、诉讼等业务。'
          },
        ],
        four: [
          {
            id: 9,
            src: require('../assets/lbtuimaj/陈瑾.jpg'),
            name: '陈瑾',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
          {
            id: 10,
            src: require('../assets/lbtuimaj/何慧君1.png'),
            name: '何惠君',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '张雪律师在法律领域有4年的公司法务及5年的律师事务所工作经验。精通公司法务层面的工作、员工法律培训、受托代理劳动仲裁、公证、诉讼等业务。进入律师事务所后为多家企业及个人提供法律服务；熟悉公司法律风险防控的预防和处理，为客户定制公司章程、各类合同文书，合同违约索赔，资信调查等各种非诉讼业务和劳动仲裁、诉讼等业务。'
          },
          {
            id: 11,
            src: require('../assets/lbtuimaj/郑静.jpg'),
            name: '郑静',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '詹宏海律师曾办理过的业务包括上海某国企破解美国杜邦公司专利围剿案；美国特斯拉汽车公司商标纠纷案；上海某风电技术公司专利侵权案；上海某国企海洋工程装备专利战略；上海某国企某生产设备专利布局规划、专利转让；上海某国企风力发电机专利检索分析等。发表代表性学术论文《知识产权贸易》 ， 《试论我国海外投资保险制度的立法完善》等。'
          },
        ],
        five: [
          {
            id: 12,
            src: require('../assets/lbtuimaj/何慧君1.png'),
            name: '何惠君',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '张雪律师在法律领域有4年的公司法务及5年的律师事务所工作经验。精通公司法务层面的工作、员工法律培训、受托代理劳动仲裁、公证、诉讼等业务。进入律师事务所后为多家企业及个人提供法律服务；熟悉公司法律风险防控的预防和处理，为客户定制公司章程、各类合同文书，合同违约索赔，资信调查等各种非诉讼业务和劳动仲裁、诉讼等业务。'
          },
          {
            id: 13,
            src: require('../assets/lbtuimaj/郑静.jpg'),
            name: '郑静',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '詹宏海律师曾办理过的业务包括上海某国企破解美国杜邦公司专利围剿案；美国特斯拉汽车公司商标纠纷案；上海某风电技术公司专利侵权案；上海某国企海洋工程装备专利战略；上海某国企某生产设备专利布局规划、专利转让；上海某国企风力发电机专利检索分析等。发表代表性学术论文《知识产权贸易》 ， 《试论我国海外投资保险制度的立法完善》等。'
          },
          {
            id: 14,
            src: require('../assets/lbtuimaj/曾彪1.png'),
            name: '曾彪',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
        ],
        six: [
          {
            id: 15,
            src: require('../assets/lbtuimaj/郑静.jpg'),
            name: '郑静',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等 ',
            school: '上海大学法学院院聘副教授',
            txt: '詹宏海律师曾办理过的业务包括上海某国企破解美国杜邦公司专利围剿案；美国特斯拉汽车公司商标纠纷案；上海某风电技术公司专利侵权案；上海某国企海洋工程装备专利战略；上海某国企某生产设备专利布局规划、专利转让；上海某国企风力发电机专利检索分析等。发表代表性学术论文《知识产权贸易》 ， 《试论我国海外投资保险制度的立法完善》等。'
          },
          {
            id: 16,
            src: require('../assets/lbtuimaj/曾彪1.png'),
            name: '曾彪',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
          {
            id: 17,
            src: require('../assets/lbtuimaj/周金阳.jpg'),
            name: '周金阳',
            rainbow: '实习律师',
            company: '擅长领域：婚姻纠纷 公司法',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
        ],
        seven: [
          {
            id: 18,
            src: require('../assets/lbtuimaj/曾彪1.png'),
            name: '曾彪',
            rainbow: '职业律师',
            company: '擅长领域：公司法、民商法、婚姻法、劳动法等',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
          {
            id: 19,
            src: require('../assets/lbtuimaj/周金阳.jpg'),
            name: '周金阳',
            rainbow: '实习律师',
            company: '擅长领域：婚姻纠纷 公司法',
            txt: '杨盛欢律师熟悉私募股权投资的全程法律事务，包括：项目尽职调查、投资方案策划与谈判、投资过程中各相关协议或文件制作；投资过程中法律风险控制；投后项目公司法律问题处理；私募基金设立与募集相关法律事务等。曾参与几十个风投项目的尽职调查，并成功为多个投资项目提供法律服务；曾为风险投资基金的设立与谈判提供法律服务。'
          },
          {
            id: 20,
            src: require('../assets/lbtuimaj/张慧靖1.png'),
            name: '张慧婧',
            rainbow: '合伙人律师',
            company: '擅长领域：企业法律顾问 公司法',
          },
        ],
      }
    }
  },
  methods: {
    showIs(index, i) {
      // let show = document.querySelectorAll(".show");
      let none = document.querySelectorAll(".none");
      // console.log(this.ImgList[i][index].id);
      show[this.ImgList[i][index].id].style.display = "none";
      none[this.ImgList[i][index].id].style.display = "block";
    },
    noShow(index, i) {
      // console.log(this.ImgList[i][index].id);
      let show = document.querySelectorAll(".show");
      let none = document.querySelectorAll(".none");
      show[this.ImgList[i][index].id].style.display = "block";
      none[this.ImgList[i][index].id].style.display = "none";
    }
  }
}
</script>

<style lang="less" scoped>
.lawyerS {
  width: 100%;
  height: 660px;
  //background: rgb(248, 248, 248);

  .lawyerSS {
    width: 1164px;
    height: 580px;
    margin: 0 auto;
    /*background: url("../assets/img/banner.png");*/
    /*background-size: cover;*/

    h2 {
      padding-top: 80px;
      text-align: center;
      font-size: 30px;
      color: rgb(43, 43, 43);
    }

    .lunbo {
      padding-top: 50px;
      width: 1100px;
      height: 360px;
      margin: 0 auto;
      margin-top: 5px;
      /*background: yellow;*/

      .block {
        width: 1100px;
        margin-top: 19px;

        .el-carousel__item {
          background: rgb(248, 248, 248);
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;

          .card {
            background: white;

            .show {
              width: 280px;
              height: 370px;
              background: white;
              float: left;
              text-align: center;
              box-shadow: 0 5px 21px 0 rgba(3, 20, 58, 0.14);

              .img {
                width: 150px;
                height: 150px;
                margin: 40px auto 0 auto;
                /*padding-top: 40px;*/
                background-size: 100% 100% !important;
              }

              p {
                font-size: 16px;
                /*padding-top: 19px;*/
              }

              p:nth-child(2) {
                padding-top: 18px;
              }

              p:nth-child(3) {
                padding-top: 18px;
              }

              p:nth-child(4) {
                padding-top: 6px;
              }

              p:nth-child(5) {
                padding-top: 6px;
              }
            }

            .none {
              display: none;
              width: 280px;
              height: 350px;
              background: white;
              float: left;
              box-shadow: 0 5px 21px 0 rgba(3, 20, 58, 0.14);
              /*text-align: center;*/

              span {
                display: block;
                padding: 20px;
                font-size: 16px;
                line-height: 26px;
              }
            }

            .show:nth-child(2) {
              margin-left: 90px;
            }

            .show:nth-child(3) {
              margin-left: 90px;
            }
          }
        }

        .el-carousel__item:nth-child(2n) {
          background-color: rgb(248, 248, 248);
        }

        .el-carousel__item:nth-child(2n+1) {
          background-color: rgb(248, 248, 248);
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/lawyerS.vue